import styled, { keyframes } from 'styled-components'

const webkitSpin = keyframes`
  0% { -webkit-transform: rotate(0deg);}
  100% { -webkit-transform: rotate(360deg);}
`

const mozSpin = keyframes`
  0% { -moz-transform: rotate(0deg);}
  100% { -moz-transform: rotate(360deg);}
`

const oSpin = keyframes`
  0% { -o-transform: rotate(0deg);}
  100% { -o-transform: rotate(360deg);}
`

const spin = keyframes`
  0% { transform: rotate(0deg);}
  100% { transform: rotate(360deg);}
`

const Spinner = styled.div<{ light?: boolean }>`
  background-image: url('${window.travURI}img/icons.png');
  background-size: auto 25px;
  display: inline-block;
  width: 25px;
  height: 25px;

  @media only screen and (min-device-pixel-ratio: 2) {
    background-image: url('${window.travURI}img/icons@2x.png');
  }

  @media only screen and (min-device-pixel-ratio: 3) {
    background-image: url('${window.travURI}img/icons@3x.png');
  }
  z-index: 999;
  overflow: show;
  margin: auto;
  width: 24px;
  height: 24px;
  -webkit-animation: ${webkitSpin} 1s steps(12) infinite;
  -moz-animation: ${mozSpin} 1s steps(12) infinite;
  -o-animation: ${oSpin} 1s steps(12) infinite;
  animation: ${spin} 1s steps(12) infinite;

  background-position: ${props => props.light ? '-25px 0' : '0 0'};
`
export { Spinner }
